
import LayoutContent from '../../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../../hooks/useRefresh';

function Index({dishMenu, setShowDetailProduct}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
      const location = useLocation();
      const { dish, alldish, currentDish } = dishMenu;
  
      const [dataDish, setDataDish] = useState(dish);
      const [dataDesserts, setDataDesserts] = useState(false);
      const [dataDrinks, setDataDrinks] = useState(false);
  
      const [image, setImage] = useState(false);
  
  
      const {change} = useRefresh();
      const [menus, setMenus] = useState([]);
  
      useEffect(() => {
          console.log('entro aca en')
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
          });
      }, [change]);
      
      
      useEffect(() => {
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
              }
          });
  
      }, [dataDish]);
  
  
       useEffect(() => {
          menus.map((item) => {
          if (item.name === 'Desserts') {
              setDataDesserts(item);
          }
  
          if (item.name === 'Soft Drinks') {
              setDataDrinks(item);
          }
          });
      }, [menus]);
  
      
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
      const navDish = (position) => {
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      };

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}>
            <LayoutContent showBack={false}>
                <h2>Hi</h2>
            </LayoutContent>
        </div>
    );
}
export default Index;